import {openDb} from "./openDb";

/**
 * Retrieves data from an IndexedDB store.
 *
 * @async
 * @function getData
 * @param {number} dbVersion - The version of the database to open.
 * @param {string} storeName - The name of the object store to retrieve data from.
 * @param {string|number} key - The key of the data to retrieve from the object store.
 * @returns {Promise<any>} A promise that resolves with the data retrieved from the store, or rejects with an error.
 *
 * @example
 * const data = await getData(1, 'object_definitions', 'someKey');
 * console.log(data);
 */
export const getData = async (dbVersion, storeName, key) => {
    // Open the database with the specified version and name.
    const db = await openDb(dbVersion, 'dams');

    // Return a promise to handle the asynchronous transaction.
    return new Promise((resolve, reject) => {
        // Start a read-only transaction on the specified object store.
        const transaction = db.transaction(storeName, 'readonly');
        const store = transaction.objectStore(storeName);

        // Attempt to retrieve the data associated with the provided key.
        const request = store.get(key);

        // Resolve the promise with the retrieved data when the request succeeds.
        request.onsuccess = (event) => {
            resolve(event.target.result);
        };

        // Reject the promise with an error if the request fails.
        request.onerror = (event) => {
            reject(event.target.error);
        };
    });
};
